import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const FuelInvOrgLayout = () => {
  const navList = useNav();
  let { FuelOrgBottom, FuelTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={FuelOrgBottom} topTabs={FuelTopHeader} />
      <Outlet />
    </div>
  )
}

export default FuelInvOrgLayout
